export default __webpack_public_path__ + "static/media/order_success.3c2f7b7e.svg";